import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShippingFast, faTruck, faBox, faQuoteLeft } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticUseCasesSection.css';
import aiRobotAssistant from "../../assets/app/Logistic/ai-robot-assistant.png";
import { useTranslation } from 'react-i18next';

const LogisticUseCasesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-cases-section" id="casos">
      <div className="logistic-container">
        <div className="logistic-section-header">
          <span className="logistic-section-tag">{t('LogisticUseCasesSection:section_tag')}</span>
          <h2>
            {t('LogisticUseCasesSection:title_prefix')}{' '}
            <span className="logistic-text-primary">{t('LogisticUseCasesSection:title_strong')}</span>
          </h2>
        </div>
        
        <div className="logistic-cases-hero-image">
          <img src={aiRobotAssistant} alt={t('LogisticUseCasesSection:alt_text')} loading="lazy" />
        </div>

        <div className="logistic-cases-grid">
          <div className="logistic-case-card">
            <div className="logistic-case-header">
              <div className="logistic-case-logo">
                <FontAwesomeIcon icon={faShippingFast} />
              </div>
              <div className="logistic-case-info">
                <h3>{t('LogisticUseCasesSection:case1_company')}</h3>
                <p>{t('LogisticUseCasesSection:case1_description')}</p>
              </div>
            </div>
            <div className="logistic-case-problem">
              <h4>{t('LogisticUseCasesSection:case1_problem_title')}</h4>
              <p>{t('LogisticUseCasesSection:case1_problem_text')}</p>
            </div>
            <div className="logistic-case-solution">
              <h4>{t('LogisticUseCasesSection:case1_solution_title')}</h4>
              <p>{t('LogisticUseCasesSection:case1_solution_text')}</p>
            </div>
            <div className="logistic-case-results">
              <h4>{t('LogisticUseCasesSection:case1_results_title')}</h4>
              <div className="logistic-results-grid">
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case1_result1_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case1_result1_label')}</span>
                </div>
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case1_result2_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case1_result2_label')}</span>
                </div>
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case1_result3_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case1_result3_label')}</span>
                </div>
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case1_result4_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case1_result4_label')}</span>
                </div>
              </div>
            </div>
            <div className="logistic-case-quote">
              <FontAwesomeIcon icon={faQuoteLeft} />
              <p>{t('LogisticUseCasesSection:case1_quote_text')}</p>
              <span>{t('LogisticUseCasesSection:case1_quote_author')}</span>
            </div>
          </div>

          <div className="logistic-case-card">
            <div className="logistic-case-header">
              <div className="logistic-case-logo">
                <FontAwesomeIcon icon={faTruck} />
              </div>
              <div className="logistic-case-info">
                <h3>{t('LogisticUseCasesSection:case2_company')}</h3>
                <p>{t('LogisticUseCasesSection:case2_description')}</p>
              </div>
            </div>
            <div className="logistic-case-problem">
              <h4>{t('LogisticUseCasesSection:case2_problem_title')}</h4>
              <p>{t('LogisticUseCasesSection:case2_problem_text')}</p>
            </div>
            <div className="logistic-case-solution">
              <h4>{t('LogisticUseCasesSection:case2_solution_title')}</h4>
              <p>{t('LogisticUseCasesSection:case2_solution_text')}</p>
            </div>
            <div className="logistic-case-results">
              <h4>{t('LogisticUseCasesSection:case2_results_title')}</h4>
              <div className="logistic-results-grid">
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case2_result1_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case2_result1_label')}</span>
                </div>
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case2_result2_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case2_result2_label')}</span>
                </div>
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case2_result3_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case2_result3_label')}</span>
                </div>
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case2_result4_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case2_result4_label')}</span>
                </div>
              </div>
            </div>
            <div className="logistic-case-quote">
              <FontAwesomeIcon icon={faQuoteLeft} />
              <p>{t('LogisticUseCasesSection:case2_quote_text')}</p>
              <span>{t('LogisticUseCasesSection:case2_quote_author')}</span>
            </div>
          </div>

          <div className="logistic-case-card">
            <div className="logistic-case-header">
              <div className="logistic-case-logo">
                <FontAwesomeIcon icon={faBox} />
              </div>
              <div className="logistic-case-info">
                <h3>{t('LogisticUseCasesSection:case3_company')}</h3>
                <p>{t('LogisticUseCasesSection:case3_description')}</p>
              </div>
            </div>
            <div className="logistic-case-problem">
              <h4>{t('LogisticUseCasesSection:case3_problem_title')}</h4>
              <p>{t('LogisticUseCasesSection:case3_problem_text')}</p>
            </div>
            <div className="logistic-case-solution">
              <h4>{t('LogisticUseCasesSection:case3_solution_title')}</h4>
              <p>{t('LogisticUseCasesSection:case3_solution_text')}</p>
            </div>
            <div className="logistic-case-results">
              <h4>{t('LogisticUseCasesSection:case3_results_title')}</h4>
              <div className="logistic-results-grid">
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case3_result1_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case3_result1_label')}</span>
                </div>
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case3_result2_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case3_result2_label')}</span>
                </div>
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case3_result3_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case3_result3_label')}</span>
                </div>
                <div className="logistic-result-item">
                  <strong>{t('LogisticUseCasesSection:case3_result4_value')}</strong>
                  <span>{t('LogisticUseCasesSection:case3_result4_label')}</span>
                </div>
              </div>
            </div>
            <div className="logistic-case-quote">
              <FontAwesomeIcon icon={faQuoteLeft} />
              <p>{t('LogisticUseCasesSection:case3_quote_text')}</p>
              <span>{t('LogisticUseCasesSection:case3_quote_author')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticUseCasesSection;